import React, { useState,useEffect } from 'react';
import {
    Autocomplete,
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Grid,
    IconButton,
    Paper,
    Switch,
    Tab,
    TextField,
} from '@mui/material'
import Typography from '@mui/material/Typography'

import Cancel from './../../../../../../assets/icons/close.png'
import itemImg from './../../../../../../assets/icons/inventory.png'
import scheduleImg from './../../../../../../assets/icons/schedule.png'
import binImg from './../../../../../../assets/icons/recycle-binColor.png'

import SchedulerComponent from '../../SchedulerView/ScheduleItemDialog/SchedulerComponent/SchedulerComponent.tsx';
import AutoCompleteMultiSelect from '../../../../../components/AutoCompleteMultiselect/AutoCompleteMultiSelect.tsx';

import CustomDataGrid from '../../../../../components/CustomDataGrid/CustomDataGrid.tsx';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import TextAreaComponents from '../../../../../components/TextAreaComponents/TextAreaComponents.tsx';
import AddItemDialogComponent from '../../../AddItemDialog.tsx';
import InventoryScheduleDialog from '../../../InventoryView/InventoryDialog/InventoryScheduleDialog/InventoryScheduleDialog.tsx';
import { toast } from 'react-toastify';
import axios from 'axios';
import SweetAlertModal from '../../../../../components/SweetAlertModal/SweetAlertModal';


function EditSubOptionDialog(props) {
    const apiAddress = process.env.REACT_APP_SECRET;
    const Restauranttoken = JSON.parse(localStorage.getItem('restaurant'));
    const [openConfirmaitonModal, setopenConfirmaitonModal] = useState(false)
    const [nameErr, setNameErr] = useState(false)
    const [priceErr, setPricErr] = useState(false)
    console.log(Restauranttoken)
    const handleClose = () => {
        //props.onClose(false)
        //props.reloadSuboption()
        props.handleEditOptionClose()
    }

    const { editData } = props;
    const [suboptionData, setsubOptionData] = React.useState();

    console.log(editData)

    useEffect(() => {
        GetSubOptiondata(editData)
    }, [editData]);

    const GetSubOptiondata = async (subOptionId) => {
        axios
            .get(
                apiAddress +
                "/api/AddOnSubOptionsMaster/GetAddOnSubOptionsMasterById?id=" +
                subOptionId
            )
            .then((response) => {
                setsubOptionData(response.data)

                setNtem(response.data.subOptionName)
                setPrice(response.data.price)

            });
    };

    const [price, setPrice] = React.useState();

    const textFieldValue = (props) => {
        console.log(props)
        setPrice(props)
        setPricErr(false)
    }

    const [name, setNtem] = React.useState('');
    const addValue = (props) => {
        console.log(props)
        setNtem(props)
        setNameErr(false)
    }
    const [open, setOpen] = React.useState(false)

    const [dataRows, setDatarows] = React.useState([]);
    const [tempdataRows, settempDatarows] = React.useState([]);


    React.useEffect(() => {
        setDatarows(tempdataRows);
    }, [dataRows])

    var data = dataRows;
    console.log(data)

    const PostSubOptionToApi = async (data) => {
        var url = apiAddress + "/api/AddOnSubOptionsMaster/UpdateAddOnSubOptionsMaster?id=" + suboptionData?.id
        var res
        await axios
            .put(url, data)
            .then((response) => {
                console.log(response.data);
                res = response.data
                toast.success("Successfully Update", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",

                });
                props.onSubOptionModelClose()
            })
            .catch((error) => {
                console.log(error)
                toast.error("failed", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
            })
        return res
    }
    
    const addData = async () => {
        setopenConfirmaitonModal(false)
        var valid = true
        if (!!name == false) {
            setNameErr(true)
            valid = false
        }
        if (!!price == false) {
            setPricErr(true)
            valid = false
        }
        if (valid) {
            var apiData = {
                id: suboptionData?.id,
                RestaurantId: Restauranttoken.id,
                subOptionName: name,
                price: price,
                creationId: "string",
                modificationId: "string"
            }
            var returnData = await PostSubOptionToApi(apiData)
        }
    }
    return (
        <div>
            <React.Fragment>
                <Dialog
                    fullWidth={true}
                    maxWidth={'md'}
                    open={props.open}
                    onClose={handleClose}
                >
                    <SweetAlertModal headerText={"Are you sure?"} bodyText={"You want to save this?"} open={openConfirmaitonModal} onyes={addData} close={() => { setopenConfirmaitonModal(false) }} />
                    <Grid container>
                        <Grid item xs={8}>
                            <DialogTitle>
                                <div className='d-flex' style={{ gap: "8px" }}>
                                    {/* <div>
                                        <img src={itemImg} style={{ width: "1.8rem" }} alt="" />
                                    </div> */}

                                    <span style={{ color: "#2a7fd4" }}>Edit sub option</span>
                                </div>
                            </DialogTitle>
                        </Grid>
                        <Grid item xs={4}>
                            <DialogActions>
                                <Button onClick={handleClose}>
                                    <img src={Cancel} alt="Close" style={{ width: '1.2rem' }} />
                                </Button>
                            </DialogActions>
                        </Grid>
                    </Grid>
                    <DialogContent style={{ backgroundColor: '#f3f0f3' }}>
                        <Grid container>
                            <Grid item xs={2}>
                                <Typography style={{ paddingTop: '1rem' }}>
                                    Name
                                </Typography>
                            </Grid>
                            <Grid item xs={9} style={{ paddingTop: '1rem' }}>

                                <TextAreaComponents label={'Name'} value={addValue} val={name} />
                                {nameErr && <span style={{ color: 'red' }}>This field is required</span>}
                            </Grid>
                        </Grid>
                        <Grid container>
                            <Grid item xs={2}>
                                <Typography style={{ paddingTop: '1rem' }}>
                                    Price
                                </Typography>
                            </Grid>
                            <Grid item xs={9} style={{ paddingTop: '1rem' }}>
                                <TextAreaComponents label={'Price'} value={textFieldValue} val={price} id={2} />
                                {priceErr && <span style={{ color: 'red' }}>This field is required</span>}
                            </Grid>
                        </Grid>
                        <Grid container sx={{ padding: '0.5rem' }}>
                            <Grid item xs={8}></Grid>
                            <Grid item xs={2}>
                                {/* <Button className="AddItemButtons">Preview</Button> */}
                            </Grid>
                        </Grid>
                        <Grid container sx={{ padding: '0.5rem' }}>
                            <Grid item xs={8}></Grid>
                            <Grid item xs={2}>
                                {/* <Button className="AddItemButtons">Preview</Button> */}
                            </Grid>
                            <Grid item xs={2}>
                                <Button className="" onClick={() => setopenConfirmaitonModal(true)}>Update</Button>
                            </Grid>
                        </Grid>

                    </DialogContent>

                </Dialog>
            </React.Fragment>
        </div>
    );
}

export default EditSubOptionDialog;